module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Listing"
  }, [_c('div', {
    staticClass: "modile-helper",
    on: {
      "click": function($event) {
        _vm.open_new_window()
      }
    }
  }, [_c('div', {
    staticClass: "info-message"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('list.title_mobile_helper')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('list.description_mobile_helper')))])])]), _vm._v(" "), (_vm.show_sort === true || _vm.show_category === true) ? _c('div', {
    staticClass: "Filters"
  }, [_c('div', {
    staticClass: "PriceFilterContainer"
  }, [(_vm.show_sort === true) ? _c('sort-by-price', {
    on: {
      "input": _vm.update_sort_order
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "CategoryFilterContainer"
  }, [(_vm.categories.length > 0 && _vm.show_category) ? _c('filter-by-category', {
    attrs: {
      "categories": _vm.categories,
      "category_id": _vm.selected_category
    },
    on: {
      "input": _vm.update_category
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "Product-List"
  }, [_vm._l((_vm.products), function(product) {
    return [_c('product', {
      key: product.product_id,
      attrs: {
        "moduleId": _vm.module_id,
        "apiUrl": _vm.api_url,
        "product": product,
        "currency": _vm.currency
      }
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ce7881d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/List.vue
// module id = 262
// module chunks = 1